import React from 'react';
import { InputNumber, Select, Button } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

const monthOptions = Array.from({ length: 12 }, (_, i) => {
  const val = String(i + 1).padStart(2, '0');
  return { value: val, label: `${val} 月` };
});

interface QueryParamsProps {
  year: number;
  month: string;
  loading: boolean;
  onYearChange: (v: number) => void;
  onMonthChange: (v: string) => void;
  onQuery: () => void;
}

const QueryParams: React.FC<QueryParamsProps> = ({
  year, month, loading,
  onYearChange, onMonthChange, onQuery,
}) => {
  return (
    <div className="bg-gray-50 border border-gray-200 rounded p-4 mb-4">
      <div className="flex flex-wrap items-center gap-4 mb-3">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium" style={{ width: 80 }}>年度月份:</span>
          <InputNumber
            value={year}
            onChange={(v) => v && onYearChange(v)}
            min={1990}
            max={2099}
            style={{ width: 100 }}
          />
          <span className="text-sm">年</span>
          <Select
            value={month}
            onChange={onMonthChange}
            options={monthOptions}
            style={{ width: 90 }}
          />
        </div>
      </div>

      <div className="flex gap-2">
        <Button type="primary" icon={<SearchOutlined />} onClick={onQuery} loading={loading}>
          查詢
        </Button>
      </div>
    </div>
  );
};

export default QueryParams;
